import {
  ICurrentUserSites,
  IPermissionModels,
  IUserRoleModels,
} from "@/interfaces/iCurrentUser";
import { computed } from "vue";
import { getCurrentUser } from "./JwtService";
import { RouteLocationNormalized } from "vue-router";
import { CrudAction, VZ_PERMISSIONS } from "@/helpers/permissionMapper";
import { GET_SELECTED_SITES, SITE_STORE } from "@/store/userSite/types";
import store from "@/store";

const viewPageModel = {
  taskboard: "VYZOR:DASHBOARD:TASKBOARD:READ",
  schedular: "VYZOR:APPLICATIONS:SCHEDULER:READ",
  email: "VYZOR:APPLICATIONS:EMAIL:READ",
  sms: "VYZOR:APPLICATIONS:SMS:READ",
  site: "VYZOR:DASHBOARD:SITES:READ",
  "email-manager": "VYZOR:INTEGRATIONS:EMAIL MANAGER:READ",
  devices: "VYZOR:INTEGRATIONS:DEVICES:READ",
  "sms-manager": "VYZOR:INTEGRATIONS:SMS MANAGER:READ",
  "user-statistics": "VYZOR:DASHBOARD:USER STATISTICS:READ",
  lookup: "VYZOR:SETTINGS:LOOKUP CONFIGURATION:READ",
};

export const hasPermission = (module: string): boolean => {
  if (module == "all" || module == null || module == undefined) {
    // to handle permissions on sub-pages
    return true;
  }
  return computed(() => {
    return (
      getCurrentUserPermissionsWithSites(getSelectedSites())?.filter(
        (permission) => permission?.toLowerCase() == module?.toLowerCase()
      ).length > 0
    );
  }).value;
};

export const hasModulePermission = (module: string): boolean => {
  return computed(() => {
    return (
      getCurrentUserPermissionsWithSites(getSelectedSites())?.filter(
        (permission) =>
          permission?.toLowerCase().split(":")[1] == module?.toLowerCase()
      ).length > 0
    );
  }).value;
};

export const getSelectedSites = () => {
  return computed(() => {
    const key = `${SITE_STORE}/${GET_SELECTED_SITES}`;
    return store.getters[key] as string;
  }).value;
};

export const getCurrentUserPermissions = (): Array<string> => {
  return computed(() => {
    return getUser()?.permissionModels?.map((perms: IPermissionModels) => {
      return perms.permissionCode;
    });
  }).value;
};

export const getCurrentUserPermissionsWithSites = (
  selectedSites: any
): Array<string> => {
  const userSitesRoles = [] as any;
  const allUserSitesIds = [] as any;
  getUser()?.currentUserSite?.map((perms: ICurrentUserSites) => {
    if (perms.userRoleId !== null) {
      allUserSitesIds.push(perms.siteId);

      selectedSites?.map((selectedSite) => {
        if (perms.siteId == parseInt(selectedSite.value)) {
          userSitesRoles.push(perms.roleName);
        }
      });
    }
  });

  if (userSitesRoles.length == 0) {
    getUser()?.currentUserSite?.map((perms: ICurrentUserSites) => {
      if (perms.userRoleId !== null) {
        userSitesRoles.push(perms.roleName);
      }
    });
  }

  return computed(() => {
    const permissionCodes = [] as any;
    if (userSitesRoles.length == 0) {
      return permissionCodes;
    }
    getUser()?.permissionModels?.map((perms: IPermissionModels) => {
      const roles = perms.rolePermissionModels.map((roleModels) => {
        return roleModels.roleName;
      });
      let allRolesHasPermissions = true;
      for (let i = 0; i < userSitesRoles.length; i++) {
        allRolesHasPermissions =
          roles.filter((role) => role == userSitesRoles[i]).length > 0;
        if (allRolesHasPermissions == false) {
          break;
        }
      }
      if (allRolesHasPermissions == true) {
        // console.log("ALL ROLE PERMISSIOS ", allRolesHasPermissions);
        permissionCodes.push(perms.permissionCode);
      }
      // extract custom permissions and add to main array of permissionCodes
      perms.rolePermissionModels
        .filter((roleModels) => roleModels.roleName == null) // server will send roleName as null if this is custom permission
        .map((customPermissions) => {
          if (selectedSites?.length > 0) {
            if (
              // check if all the siteIds are of those siteIds which are currently selected by user
              selectedSites
                .map((sit) => {
                  return parseInt(sit.value);
                })
                .every((element) => {
                  return perms.siteIds.includes(parseInt(element));
                })
            ) {
              permissionCodes.push(customPermissions.permissionCode);
            }
          } else {
            // Check if all the siteIds which are assiged to user have same IDs as of this custom permission assinged siteIDs
            const containsAll = (arr1, arr2) =>
              arr2?.every((arr2Item) => arr1?.includes(arr2Item));

            const sameMembers = (arr1, arr2) =>
              containsAll(arr1, arr2) && containsAll(arr2, arr1);

            if (sameMembers(perms.siteIds, allUserSitesIds)) {
              permissionCodes.push(customPermissions.permissionCode);
            }
          }
        });
    });
    return permissionCodes;
  }).value;
};

export const getCurrentUserRoles = (): Array<string> => {
  return computed(() => {
    return getUser()?.userRoleModels?.map((roles: IUserRoleModels) => {
      return roles.name;
    });
  }).value;
};

const getUser = () => {
  return computed(() => {
    return getCurrentUser();
  }).value;
};

export const hasPagePermission = (to: RouteLocationNormalized): boolean => {
  if (to.meta && to.meta.PERMISSION && getUser()) {
    const permission = to.meta?.PERMISSION as VZ_PERMISSIONS;
    return hasPermissionWrapper(permission);
  }
  return true;
};

export const hasPermissionWrapper = (
  moduleName: VZ_PERMISSIONS,
  action: CrudAction = "READ"
): boolean => {
  if (moduleName && getUser()) {
    const permission = `${moduleName}:${action}`;
    return hasPermission(permission);
  }
  return true;
};

export const hasModulePermissionWrapper = (moduleName: string): boolean => {
  if (moduleName && getUser()) {
    return hasModulePermission(moduleName);
  }
  return true;
};
